import React, { useState, useEffect } from 'react';
import { useRouter } from 'next/router';
import Box from '@mui/material/Box';
import CssBaseline from '@mui/material/CssBaseline';
import MenuIcon from '@mui/icons-material/Menu';
import { isMobile } from 'react-device-detect';
import OwnerSidebar from '@components/Owner/Sidebar/Sidebar';
import { safeLocalStorage } from '@utils/localstorage';
import { imageSrc } from '@utils/imageSrc';
import EarthRoverIcon from '@images/owner/earthrover.svg';

const drawerWidth = 300;

const OwnerLayout = ({ children }) => {
	const router = useRouter();
	const [mobileOpen, setMobileOpen] = useState(false);
	const [isClosing, setIsClosing] = useState(false);
	const authToken = safeLocalStorage.getItem('authToken');

	/**
	 * Replaces `<Helmet bodyAttributes={{ class: 'owner-dashboard' }} />`. Next.js's
	 * `next/head` can't set body attributes, so we toggle the class imperatively
	 * and clean it up on unmount/route change.
	 */
	useEffect(() => {
		document.body.classList.add('owner-dashboard');
		return () => {
			document.body.classList.remove('owner-dashboard');
		};
	}, []);

	const handleDrawerClose = () => {
		setIsClosing(true);
		setMobileOpen(false);
	};

	const handleDrawerTransitionEnd = () => {
		setIsClosing(false);
	};

	const handleDrawerToggle = () => {
		if (!isClosing) {
			setMobileOpen(!mobileOpen);
		}
	};

	useEffect(() => {
		if (!authToken) {
			router.push('/dashboard-login');
		}
	}, [authToken]);

	if (!authToken) {
		return <></>;
	}

	return (
		<Box sx={{ display: 'flex' }}>
			<CssBaseline />
			<header className="flex justify-between items-center w-full h-40 p-8 fixed sm:hidden z-50 bg-[#f6f6f6] border-b-2 border-[#008735]">
				<button onClick={handleDrawerToggle}>
					<MenuIcon />
				</button>
				<Box className="flex items-center gap-[8px]">
					<img src={imageSrc(EarthRoverIcon)} alt="earth-rover" />
					<Box className="flex flex-col items-start gap-[-2px]">
						<Box className="flex pb-px justify-end items-center">
							<p className="text-[#000] text-[18px] not-italic font-semibold leading-[22px] tracking-[-0.72px]">
								EarthRovers
							</p>
						</Box>
						<p className="text-[#868686] text-[14px] not-italic font-medium leading-[14px] tracking-[-0.56px]">
							by FrodoBots
						</p>
					</Box>
				</Box>
			</header>
			<OwnerSidebar
				mobileOpen={mobileOpen}
				handleDrawerTransitionEnd={handleDrawerTransitionEnd}
				handleDrawerClose={handleDrawerClose}
				drawerWidth={drawerWidth}
			/>
			<Box
				component="main"
				sx={{
					flexGrow: 1,
					width: { sm: `calc(100% - ${drawerWidth}px)`, xs: '100%' },
					padding: isMobile ? '14px' : '36px',
					paddingTop: isMobile ? '80px' : ''
				}}
			>
				{children}
			</Box>
		</Box>
	);
};

export default OwnerLayout;
